import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { AccountService } from './account.service';
import { SCAMP_API } from 'src/environments/environment';
import { Observable } from 'rxjs';
import { UsuarioCadastrado } from '../models/usuario-cadastrado.model';
import { DomSanitizer } from '@angular/platform-browser';
import { Usuario } from '../models/usuario.model';
import { UsuarioCB } from 'src/app/models/usuario-cb.model';
import { UsuarioAutorizacoes } from '../models/usuario.autorizacoes.model';
import { Security } from 'src/app/utils/security.util';
import { Router } from '@angular/router';

@Injectable({ providedIn: 'root' })
export class UsuarioService {


    constructor(
        private http: HttpClient,
        private account: AccountService,
        private sanitizer: DomSanitizer,
        private router: Router
    ) { }

    getAutorizacoesJanelaPorRota(rota: string): UsuarioAutorizacoes {
        const autorizacoesUsuarioLogado = Security.getAutorizacoes();

        if (autorizacoesUsuarioLogado) {

            const autorizacoes = autorizacoesUsuarioLogado.filter(a => a.rota.toLowerCase() === rota.toLowerCase() && a.tipo === 1)[0];

            if (autorizacoes === undefined || autorizacoes == null) {
                this.router.navigate(['/not-authorized']);
            } else {
                if (autorizacoes.podeAcessar === false) {
                    this.router.navigate(['/not-authorized']);
                } else {
                    return autorizacoes;
                }
            }


        } else {
            return null;
        }
    }

    getAutorizacoesEspecificaPorRota(rota: string, especifica: string): boolean {
        const autorizacoesUsuarioLogado = Security.getAutorizacoes();

        if (autorizacoesUsuarioLogado) {
            const autorizacoEspecifica = autorizacoesUsuarioLogado.filter(a =>
                a.rota.toLowerCase() === rota.toLowerCase() &&
                a.tipo === 2 &&
                a.especifica === especifica)[0];

            if (autorizacoEspecifica != null || autorizacoEspecifica !== undefined) {
                return autorizacoEspecifica.estaAutorizado;
            } else {
                return false;
            }
        } else {
            return null;
        }
    }

    // Não usar mais
    getAutorizacoesPorClaim(rota: string): UsuarioAutorizacoes {
        const autorizacoesUsuarioLogado = Security.getAutorizacoes();

        if (autorizacoesUsuarioLogado) {
            return autorizacoesUsuarioLogado.filter(a => a.rota.toLowerCase() === rota.toLowerCase())[0];
        } else {
            return null;
        }
    }

    getAutorizacoesPorFuncionalidadeId(id: number): UsuarioAutorizacoes {
        const autorizacoesUsuarioLogado = Security.getAutorizacoes();

        if (autorizacoesUsuarioLogado) {
            return autorizacoesUsuarioLogado.filter(a => a.funcionalidadeId === id)[0];
        } else {
            return null;
        }

    }

    getUsuarioLogadoId() { return Security.getUser().id; }

    getUsuariosCadastrados(): Observable<UsuarioCadastrado[]> {
        return this.http.get<UsuarioCadastrado[]>(`${SCAMP_API.accountApiV1}/users-cadastrados`,
            { headers: this.account.composeHeaders() });
    }

    getUsuarioCadastradoPorNomeLogin(nomeLogin: string): Observable<UsuarioCadastrado[]> {
        return this.http.get<UsuarioCadastrado[]>(`${SCAMP_API.accountApiV1}/usuarios/pornomelogin/${nomeLogin}`,
            { headers: this.account.composeHeaders() });
    }


    getUsuarioAutorizacoes(id: number): Observable<UsuarioAutorizacoes[]> {
        return this.http.get<UsuarioAutorizacoes[]>(`${SCAMP_API.accountApiV1}/usuario-autorizacoes/${id}`,
            { headers: this.account.composeHeaders() });
    }

    getUsuarioCadastrado(id: number): Observable<UsuarioCadastrado> {
        return this.http.get<UsuarioCadastrado>(`${SCAMP_API.accountApiV1}/user/${id}`, { headers: this.account.composeHeaders() });
    }

    getUsuariosCB(): Observable<UsuarioCB[]> {
        return this.http.get<UsuarioCB[]>(`${SCAMP_API.accountApiV1}/usuarios-cb/`, { headers: this.account.composeHeaders() });
    }

    getUsuario(id: number): Observable<Usuario> {
        return this.http.get<Usuario>(`${SCAMP_API.accountApiV1}/usuario/${id}`, { headers: this.account.composeHeaders() });
    }

    registrar(data) {
        return this.http.post(`${SCAMP_API.accountApiV1}/usuario`, data, { headers: this.account.composeHeaders() });
    }

    editar(id: number, data) {
        return this.http.put(`${SCAMP_API.accountApiV1}/usuario/${id}`, data, { headers: this.account.composeHeaders() });
    }

    resertarSenha(id: number) {
        return this.http.put(`${SCAMP_API.accountApiV1}/usuario-resetar-senha/${id}`, '', { headers: this.account.composeHeaders() });
    }

    ativarDesativar(id: number) {
        return this.http.put(`${SCAMP_API.accountApiV1}/usuario-ativar-desativar/${id}`, '', { headers: this.account.composeHeaders() });
    }

    getSantizeUrl(fotoMimeType: string, foto: string) {

        const url = `data:${fotoMimeType};base64, ${foto}`;
        return this.sanitizer.bypassSecurityTrustUrl(url);
    }

    bypassSecurityTrustUrl(url: string) {
        return this.sanitizer.bypassSecurityTrustUrl(url);
    }

    getFotoUsuario(id: number): Observable<any> {
        return this.http.get<any>(`${SCAMP_API.accountApiV1}/usuario-foto/${id}`, { headers: this.account.composeHeaders() });
    }

    alterarSenha(id: number, data) {
        return this.http.put(`${SCAMP_API.accountApiV1}/usuario-alterar-senha/${id}`, data, { headers: this.account.composeHeaders() });
    }

}
